import React from 'react';
import { Navigate } from 'react-router-dom';

export const isAuthenticated = () => {
  return !!localStorage.getItem('user_id') && !!localStorage.getItem('student_token');
};

export const isGuruAuthenticated = () => {
  return !!localStorage.getItem('guru_id') && !!localStorage.getItem('guru_api_token');
};

// Untuk route yang hanya bisa diakses jika sudah login
export const ProtectedRoute = ({ children }) => {
  return isAuthenticated() && localStorage.getItem('account_type') !== 'guru'
    ? children
    : <Navigate to={isGuruAuthenticated() ? '/guru' : '/login'} replace />;
};

export const GuruProtectedRoute = ({ children }) => {
  return isGuruAuthenticated()
    ? children
    : <Navigate to={isAuthenticated() ? '/dashboard' : '/login'} replace />;
};

// Untuk route seperti /login, tidak bisa diakses jika sudah login
export const RedirectIfAuthenticated = ({ children }) => {
  if (isGuruAuthenticated()) return <Navigate to="/guru" replace />;
  return isAuthenticated() ? <Navigate to="/dashboard" replace /> : children;
};
